<template>
  <div class="position-relative w-240">
    <div
      @click="request(module.module.id)"
      class="card py-1 cursor-pointer w-240 mb-1"
      :class="{
        'bg-secondary text-white':
          expandedModuleId === module.module.id && module.module.is_child,
      }"
    >
      <div class="d-flex align-items-center justify-content-between pl-1 pr-50">
        <b class="d-block">
          {{ module.module && module.module.title[$i18n.locale] }}
        </b>
        <div class="d-flex align-items-center gap-2">
          <feather-icon
            v-if="module.module.is_child"
            icon="ChevronRightIcon"
            :color="
              expandedModuleId === module.module.id ? '#ffffff' : '#30499A'
            "
            size="14"
          />
          <div @click.stop>
            <b-form-checkbox
              switch
              :class="
                module.draft_is_active !== module.is_active
                  ? 'custom-control-warning'
                  : 'custom-control-primary'
              "
              v-model="module.draft_is_active"
              @change="savePermission"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="expandedModuleId === module.module.id"
      class="position-absolute"
      style="left: 260px; top: 0;"
    >
      <ModuleCard
        v-for="item in treeData"
        :key="item.id"
        :module="item"
        :id="id"
        :moduleArray="treeData"
        :expandedModuleId="expandedChildId"
        @expandedModule="expandedChildId = $event"
        @activateParent="activateParent"
      />
    </div>
  </div>
</template>

<script>
import { BFormCheckbox, BButton } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import ModuleCard from './ModuleCard.vue'

export default {
  name: 'ModuleCard',
  components: {
    BFormCheckbox,
    BButton,
    ModuleCard,
  },
  props: {
    module: Object,
    moduleArray: Array,
    id: { type: [Number, String, null], default: null },
    expandedModuleId: { type: [Number, null], default: null },
  },
  data() {
    return {
      treeData: [],
      expandedChildId: null,
    }
  },
  computed: {
    ...mapGetters('administration', ['GET_MODULE_LIST_CHILDREN']),
  },
  methods: {
    ...mapActions('administration', [
      'getPermissionModuleChildren',
      'updatePermissionStatus',
    ]),

    async request(moduleId) {
      console.log('mid', moduleId)

      this.$emit(
        'expandedModule',
        this.expandedModuleId === moduleId ? null : moduleId
      )
      if (this.expandedModuleId !== moduleId) {
        try {
          this.treeData = []
          await this.getPermissionModuleChildren({
            role_id: this.id,
            parent: moduleId,
          })
          this.treeData.splice(
            0,
            this.treeData.length,
            ...this.GET_MODULE_LIST_CHILDREN
          )
        } catch (error) {
          this.$_errorToast(error.response?.data?.message || error.message)
        }
      }
    },

    updateTreeDataState(isActive) {
      this.treeData = this.treeData.map((item) => ({
        ...item,
        draft_is_active: isActive,
      }))
    },

    activateParent(value) {
      this.module.draft_is_active = value
      const isActiveParent = this.moduleArray.some(
        (item) => item.draft_is_active
      )
      this.$emit('activateParent', isActiveParent)
    },

    async savePermission() {
      const isActive = this.module.draft_is_active

      if (this.expandedModuleId === this.module.module.id) {
        this.updateTreeDataState(isActive)
      }

      try {
        await this.updatePermissionStatus({
          id: this.module.id,
          draft_is_active: isActive,
        })

        const isActiveParent = this.moduleArray.some(
          (item) => item.draft_is_active
        )
        this.$emit('activateParent', isActiveParent)
      } catch (error) {
        this.$_errorToast(error.response?.data?.message || error.message)
      }
    },
  },
  watch: {
    expandedModuleId() {
      this.expandedChildId = null
    },
    moduleArray: {
      handler() {
        if (this.expandedModuleId === this.module.module.id) {
          this.updateTreeDataState(this.module.draft_is_active)
        }
      },
    },
  },
}
</script>

<style scoped>
.w-240 {
  width: 240px;
}
.cursor-pointer {
  cursor: pointer;
}
.gap-2 {
  gap: 0.5rem;
}
.position-absolute {
  position: absolute;
}
.position-relative {
  position: relative;
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
  display: block;
}
</style>
